import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import Vue from 'vue';
import Router from 'vue-router';
import { normalizeURL } from 'ufo';
import { interopDefault } from './utils';
import scrollBehavior from './router.scrollBehavior.js';

var _e220dcf0 = function _e220dcf0() {
  return interopDefault(import('../pages/account-verification/index.vue'
  /* webpackChunkName: "pages/account-verification/index" */
  ));
};

var _114cd11b = function _114cd11b() {
  return interopDefault(import('../pages/bursaries/index.vue'
  /* webpackChunkName: "pages/bursaries/index" */
  ));
};

var _c2ca05be = function _c2ca05be() {
  return interopDefault(import('../pages/courses/index.vue'
  /* webpackChunkName: "pages/courses/index" */
  ));
};

var _cd2cfa34 = function _cd2cfa34() {
  return interopDefault(import('../pages/events/index.vue'
  /* webpackChunkName: "pages/events/index" */
  ));
};

var _1dc8596a = function _1dc8596a() {
  return interopDefault(import('../pages/faqs/index.vue'
  /* webpackChunkName: "pages/faqs/index" */
  ));
};

var _59c1bda4 = function _59c1bda4() {
  return interopDefault(import('../pages/forgot-password/index.vue'
  /* webpackChunkName: "pages/forgot-password/index" */
  ));
};

var _4ca94788 = function _4ca94788() {
  return interopDefault(import('../pages/general-preferences/index.vue'
  /* webpackChunkName: "pages/general-preferences/index" */
  ));
};

var _7b00549f = function _7b00549f() {
  return interopDefault(import('../pages/interviews/index.vue'
  /* webpackChunkName: "pages/interviews/index" */
  ));
};

var _3d012a63 = function _3d012a63() {
  return interopDefault(import('../pages/jobs/index.vue'
  /* webpackChunkName: "pages/jobs/index" */
  ));
};

var _4651e442 = function _4651e442() {
  return interopDefault(import('../pages/LoadTest.vue'
  /* webpackChunkName: "pages/LoadTest" */
  ));
};

var _d39949dc = function _d39949dc() {
  return interopDefault(import('../pages/login/index.vue'
  /* webpackChunkName: "pages/login/index" */
  ));
};

var _2316ea4e = function _2316ea4e() {
  return interopDefault(import('../pages/messages/index.vue'
  /* webpackChunkName: "pages/messages/index" */
  ));
};

var _27e36b44 = function _27e36b44() {
  return interopDefault(import('../pages/mock-interviews/index.vue'
  /* webpackChunkName: "pages/mock-interviews/index" */
  ));
};

var _4916e5ee = function _4916e5ee() {
  return interopDefault(import('../pages/my-details/index.vue'
  /* webpackChunkName: "pages/my-details/index" */
  ));
};

var _6f2b1a80 = function _6f2b1a80() {
  return interopDefault(import('../pages/my-jobs/index.vue'
  /* webpackChunkName: "pages/my-jobs/index" */
  ));
};

var _72a32223 = function _72a32223() {
  return interopDefault(import('../pages/notification-preferences/index.vue'
  /* webpackChunkName: "pages/notification-preferences/index" */
  ));
};

var _3806805e = function _3806805e() {
  return interopDefault(import('../pages/notifications/index.vue'
  /* webpackChunkName: "pages/notifications/index" */
  ));
};

var _3aad8ce9 = function _3aad8ce9() {
  return interopDefault(import('../pages/saved-jobs/index.vue'
  /* webpackChunkName: "pages/saved-jobs/index" */
  ));
};

var _6933e4f0 = function _6933e4f0() {
  return interopDefault(import('../pages/settings/index.vue'
  /* webpackChunkName: "pages/settings/index" */
  ));
};

var _8b7a7d6a = function _8b7a7d6a() {
  return interopDefault(import('../pages/university-management/index.vue'
  /* webpackChunkName: "pages/university-management/index" */
  ));
};

var _1677684b = function _1677684b() {
  return interopDefault(import('../pages/welcome/index.vue'
  /* webpackChunkName: "pages/welcome/index" */
  ));
};

var _4f936028 = function _4f936028() {
  return interopDefault(import('../pages/account/create.vue'
  /* webpackChunkName: "pages/account/create" */
  ));
};

var _51d58b36 = function _51d58b36() {
  return interopDefault(import('../pages/account/edit.vue'
  /* webpackChunkName: "pages/account/edit" */
  ));
};

var _bf39ca34 = function _bf39ca34() {
  return interopDefault(import('../pages/account/verify-university.vue'
  /* webpackChunkName: "pages/account/verify-university" */
  ));
};

var _69bbf4bd = function _69bbf4bd() {
  return interopDefault(import('../pages/email-verification/backup-email/index.vue'
  /* webpackChunkName: "pages/email-verification/backup-email/index" */
  ));
};

var _2daf9db6 = function _2daf9db6() {
  return interopDefault(import('../pages/jobs/applications/index.vue'
  /* webpackChunkName: "pages/jobs/applications/index" */
  ));
};

var _115f1b2c = function _115f1b2c() {
  return interopDefault(import('../pages/profile/create.vue'
  /* webpackChunkName: "pages/profile/create" */
  ));
};

var _5de6df66 = function _5de6df66() {
  return interopDefault(import('../pages/profile/cv/index.vue'
  /* webpackChunkName: "pages/profile/cv/index" */
  ));
};

var _2a9c373a = function _2a9c373a() {
  return interopDefault(import('../pages/profile/edit.vue'
  /* webpackChunkName: "pages/profile/edit" */
  ));
};

var _443535dd = function _443535dd() {
  return interopDefault(import('../pages/profile/progress.vue'
  /* webpackChunkName: "pages/profile/progress" */
  ));
};

var _56303912 = function _56303912() {
  return interopDefault(import('../pages/profile/cv/about-me/index.vue'
  /* webpackChunkName: "pages/profile/cv/about-me/index" */
  ));
};

var _8a7aaff4 = function _8a7aaff4() {
  return interopDefault(import('../pages/profile/cv/additional/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/index" */
  ));
};

var _3f738ebf = function _3f738ebf() {
  return interopDefault(import('../pages/profile/cv/education/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/index" */
  ));
};

var _0d0a68b4 = function _0d0a68b4() {
  return interopDefault(import('../pages/profile/cv/employability-awards/index.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/index" */
  ));
};

var _1bbd226e = function _1bbd226e() {
  return interopDefault(import('../pages/profile/cv/fluent-languages/index.vue'
  /* webpackChunkName: "pages/profile/cv/fluent-languages/index" */
  ));
};

var _7f32ee3d = function _7f32ee3d() {
  return interopDefault(import('../pages/profile/cv/general-reference/index.vue'
  /* webpackChunkName: "pages/profile/cv/general-reference/index" */
  ));
};

var _9c29ff40 = function _9c29ff40() {
  return interopDefault(import('../pages/profile/cv/interests/index.vue'
  /* webpackChunkName: "pages/profile/cv/interests/index" */
  ));
};

var _b857273e = function _b857273e() {
  return interopDefault(import('../pages/profile/cv/skills/index.vue'
  /* webpackChunkName: "pages/profile/cv/skills/index" */
  ));
};

var _72d70199 = function _72d70199() {
  return interopDefault(import('../pages/profile/cv/template/index.vue'
  /* webpackChunkName: "pages/profile/cv/template/index" */
  ));
};

var _65e27100 = function _65e27100() {
  return interopDefault(import('../pages/profile/cv/transport/index.vue'
  /* webpackChunkName: "pages/profile/cv/transport/index" */
  ));
};

var _e949d140 = function _e949d140() {
  return interopDefault(import('../pages/profile/cv/upload/index.vue'
  /* webpackChunkName: "pages/profile/cv/upload/index" */
  ));
};

var _79dd6e3d = function _79dd6e3d() {
  return interopDefault(import('../pages/profile/cv/work-experience/index.vue'
  /* webpackChunkName: "pages/profile/cv/work-experience/index" */
  ));
};

var _08778326 = function _08778326() {
  return interopDefault(import('../pages/profile/cv/additional/achievement/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/achievement/index" */
  ));
};

var _2911c573 = function _2911c573() {
  return interopDefault(import('../pages/profile/cv/additional/external-link/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-link/index" */
  ));
};

var _05582076 = function _05582076() {
  return interopDefault(import('../pages/profile/cv/additional/external-links/index.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-links/index" */
  ));
};

var _72f5d1e6 = function _72f5d1e6() {
  return interopDefault(import('../pages/profile/cv/education/additional/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/additional/index" */
  ));
};

var _57617b9a = function _57617b9a() {
  return interopDefault(import('../pages/profile/cv/education/school/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/school/index" */
  ));
};

var _6ccfd438 = function _6ccfd438() {
  return interopDefault(import('../pages/profile/cv/education/tertiary/index.vue'
  /* webpackChunkName: "pages/profile/cv/education/tertiary/index" */
  ));
};

var _8f96270c = function _8f96270c() {
  return interopDefault(import('../pages/profile/cv/employability-awards/checklist.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/checklist" */
  ));
};

var _44f0ede6 = function _44f0ede6() {
  return interopDefault(import('../pages/profile/cv/employability-awards/ChecklistItem.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/ChecklistItem" */
  ));
};

var _5132ed99 = function _5132ed99() {
  return interopDefault(import('../pages/profile/cv/employability-awards/LogUpload.vue'
  /* webpackChunkName: "pages/profile/cv/employability-awards/LogUpload" */
  ));
};

var _f38fd1e4 = function _f38fd1e4() {
  return interopDefault(import('../pages/profile/cv/additional/achievement/_id.vue'
  /* webpackChunkName: "pages/profile/cv/additional/achievement/_id" */
  ));
};

var _bdaeeeca = function _bdaeeeca() {
  return interopDefault(import('../pages/profile/cv/additional/external-link/_id.vue'
  /* webpackChunkName: "pages/profile/cv/additional/external-link/_id" */
  ));
};

var _42d10e96 = function _42d10e96() {
  return interopDefault(import('../pages/profile/cv/education/additional/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/additional/_id" */
  ));
};

var _e724c6fc = function _e724c6fc() {
  return interopDefault(import('../pages/profile/cv/education/school/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/school/_id" */
  ));
};

var _743584a0 = function _743584a0() {
  return interopDefault(import('../pages/profile/cv/education/tertiary/_id.vue'
  /* webpackChunkName: "pages/profile/cv/education/tertiary/_id" */
  ));
};

var _16315be5 = function _16315be5() {
  return interopDefault(import('../pages/profile/cv/general-reference/_id.vue'
  /* webpackChunkName: "pages/profile/cv/general-reference/_id" */
  ));
};

var _8d084836 = function _8d084836() {
  return interopDefault(import('../pages/profile/cv/work-experience/_id.vue'
  /* webpackChunkName: "pages/profile/cv/work-experience/_id" */
  ));
};

var _408a3190 = function _408a3190() {
  return interopDefault(import('../pages/jobs/applications/_id/index.vue'
  /* webpackChunkName: "pages/jobs/applications/_id/index" */
  ));
};

var _f65c32f4 = function _f65c32f4() {
  return interopDefault(import('../pages/bursaries/_id/index.vue'
  /* webpackChunkName: "pages/bursaries/_id/index" */
  ));
};

var _ecee1a72 = function _ecee1a72() {
  return interopDefault(import('../pages/interviews/_id.vue'
  /* webpackChunkName: "pages/interviews/_id" */
  ));
};

var _beaf4864 = function _beaf4864() {
  return interopDefault(import('../pages/jobs/_id/index.vue'
  /* webpackChunkName: "pages/jobs/_id/index" */
  ));
};

var _39ad20fe = function _39ad20fe() {
  return interopDefault(import('../pages/messages/_id.vue'
  /* webpackChunkName: "pages/messages/_id" */
  ));
};

var _aa7005e4 = function _aa7005e4() {
  return interopDefault(import('../pages/reset-password/_id.vue'
  /* webpackChunkName: "pages/reset-password/_id" */
  ));
};

var _3e360287 = function _3e360287() {
  return interopDefault(import('../pages/bursaries/_id/application/index.vue'
  /* webpackChunkName: "pages/bursaries/_id/application/index" */
  ));
};

var _3fdecbcf = function _3fdecbcf() {
  return interopDefault(import('../pages/jobs/_id/application/index.vue'
  /* webpackChunkName: "pages/jobs/_id/application/index" */
  ));
};

var _716188b8 = function _716188b8() {
  return interopDefault(import('../pages/index.vue'
  /* webpackChunkName: "pages/index" */
  ));
};

var emptyFn = function emptyFn() {};

Vue.use(Router);
export var routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior: scrollBehavior,
  routes: [{
    path: "/account-verification",
    component: _e220dcf0,
    name: "account-verification___en"
  }, {
    path: "/af/account-verification",
    component: _e220dcf0,
    name: "account-verification___af"
  }, {
    path: "/bursaries",
    component: _114cd11b,
    name: "bursaries___en"
  }, {
    path: "/af/bursaries",
    component: _114cd11b,
    name: "bursaries___af"
  }, {
    path: "/courses",
    component: _c2ca05be,
    name: "courses___en"
  }, {
    path: "/af/courses",
    component: _c2ca05be,
    name: "courses___af"
  }, {
    path: "/events",
    component: _cd2cfa34,
    name: "events___en"
  }, {
    path: "/af/events",
    component: _cd2cfa34,
    name: "events___af"
  }, {
    path: "/faqs",
    component: _1dc8596a,
    name: "faqs___en"
  }, {
    path: "/af/faqs",
    component: _1dc8596a,
    name: "faqs___af"
  }, {
    path: "/forgot-password",
    component: _59c1bda4,
    name: "forgot-password___en"
  }, {
    path: "/af/forgot-password",
    component: _59c1bda4,
    name: "forgot-password___af"
  }, {
    path: "/general-preferences",
    component: _4ca94788,
    name: "general-preferences___en"
  }, {
    path: "/af/general-preferences",
    component: _4ca94788,
    name: "general-preferences___af"
  }, {
    path: "/interviews",
    component: _7b00549f,
    name: "interviews___en"
  }, {
    path: "/af/interviews",
    component: _7b00549f,
    name: "interviews___af"
  }, {
    path: "/jobs",
    component: _3d012a63,
    name: "jobs___en"
  }, {
    path: "/af/jobs",
    component: _3d012a63,
    name: "jobs___af"
  }, {
    path: "/LoadTest",
    component: _4651e442,
    name: "LoadTest___en"
  }, {
    path: "/af/LoadTest",
    component: _4651e442,
    name: "LoadTest___af"
  }, {
    path: "/login",
    component: _d39949dc,
    name: "login___en"
  }, {
    path: "/af/login",
    component: _d39949dc,
    name: "login___af"
  }, {
    path: "/messages",
    component: _2316ea4e,
    name: "messages___en"
  }, {
    path: "/af/messages",
    component: _2316ea4e,
    name: "messages___af"
  }, {
    path: "/mock-interviews",
    component: _27e36b44,
    name: "mock-interviews___en"
  }, {
    path: "/af/mock-interviews",
    component: _27e36b44,
    name: "mock-interviews___af"
  }, {
    path: "/my-details",
    component: _4916e5ee,
    name: "my-details___en"
  }, {
    path: "/af/my-details",
    component: _4916e5ee,
    name: "my-details___af"
  }, {
    path: "/my-jobs",
    component: _6f2b1a80,
    name: "my-jobs___en"
  }, {
    path: "/af/my-jobs",
    component: _6f2b1a80,
    name: "my-jobs___af"
  }, {
    path: "/notification-preferences",
    component: _72a32223,
    name: "notification-preferences___en"
  }, {
    path: "/af/notification-preferences",
    component: _72a32223,
    name: "notification-preferences___af"
  }, {
    path: "/notifications",
    component: _3806805e,
    name: "notifications___en"
  }, {
    path: "/af/notifications",
    component: _3806805e,
    name: "notifications___af"
  }, {
    path: "/saved-jobs",
    component: _3aad8ce9,
    name: "saved-jobs___en"
  }, {
    path: "/af/saved-jobs",
    component: _3aad8ce9,
    name: "saved-jobs___af"
  }, {
    path: "/settings",
    component: _6933e4f0,
    name: "settings___en"
  }, {
    path: "/af/settings",
    component: _6933e4f0,
    name: "settings___af"
  }, {
    path: "/university-management",
    component: _8b7a7d6a,
    name: "university-management___en"
  }, {
    path: "/af/university-management",
    component: _8b7a7d6a,
    name: "university-management___af"
  }, {
    path: "/welcome",
    component: _1677684b,
    name: "welcome___en"
  }, {
    path: "/af/welcome",
    component: _1677684b,
    name: "welcome___af"
  }, {
    path: "/account/create",
    component: _4f936028,
    name: "account-create___en"
  }, {
    path: "/af/account/create",
    component: _4f936028,
    name: "account-create___af"
  }, {
    path: "/account/edit",
    component: _51d58b36,
    name: "account-edit___en"
  }, {
    path: "/af/account/edit",
    component: _51d58b36,
    name: "account-edit___af"
  }, {
    path: "/account/verify-university",
    component: _bf39ca34,
    name: "account-verify-university___en"
  }, {
    path: "/af/account/verify-university",
    component: _bf39ca34,
    name: "account-verify-university___af"
  }, {
    path: "/email-verification/backup-email",
    component: _69bbf4bd,
    name: "email-verification-backup-email___en"
  }, {
    path: "/af/email-verification/backup-email",
    component: _69bbf4bd,
    name: "email-verification-backup-email___af"
  }, {
    path: "/jobs/applications",
    component: _2daf9db6,
    name: "jobs-applications___en"
  }, {
    path: "/af/jobs/applications",
    component: _2daf9db6,
    name: "jobs-applications___af"
  }, {
    path: "/profile/create",
    component: _115f1b2c,
    name: "profile-create___en"
  }, {
    path: "/af/profile/create",
    component: _115f1b2c,
    name: "profile-create___af"
  }, {
    path: "/profile/cv",
    component: _5de6df66,
    name: "profile-cv___en"
  }, {
    path: "/af/profile/cv",
    component: _5de6df66,
    name: "profile-cv___af"
  }, {
    path: "/profile/edit",
    component: _2a9c373a,
    name: "profile-edit___en"
  }, {
    path: "/af/profile/edit",
    component: _2a9c373a,
    name: "profile-edit___af"
  }, {
    path: "/profile/progress",
    component: _443535dd,
    name: "profile-progress___en"
  }, {
    path: "/af/profile/progress",
    component: _443535dd,
    name: "profile-progress___af"
  }, {
    path: "/profile/cv/about-me",
    component: _56303912,
    name: "profile-cv-about-me___en"
  }, {
    path: "/af/profile/cv/about-me",
    component: _56303912,
    name: "profile-cv-about-me___af"
  }, {
    path: "/profile/cv/additional",
    component: _8a7aaff4,
    name: "profile-cv-additional___en"
  }, {
    path: "/af/profile/cv/additional",
    component: _8a7aaff4,
    name: "profile-cv-additional___af"
  }, {
    path: "/profile/cv/education",
    component: _3f738ebf,
    name: "profile-cv-education___en"
  }, {
    path: "/af/profile/cv/education",
    component: _3f738ebf,
    name: "profile-cv-education___af"
  }, {
    path: "/profile/cv/employability-awards",
    component: _0d0a68b4,
    name: "profile-cv-employability-awards___en"
  }, {
    path: "/af/profile/cv/employability-awards",
    component: _0d0a68b4,
    name: "profile-cv-employability-awards___af"
  }, {
    path: "/profile/cv/fluent-languages",
    component: _1bbd226e,
    name: "profile-cv-fluent-languages___en"
  }, {
    path: "/af/profile/cv/fluent-languages",
    component: _1bbd226e,
    name: "profile-cv-fluent-languages___af"
  }, {
    path: "/profile/cv/general-reference",
    component: _7f32ee3d,
    name: "profile-cv-general-reference___en"
  }, {
    path: "/af/profile/cv/general-reference",
    component: _7f32ee3d,
    name: "profile-cv-general-reference___af"
  }, {
    path: "/profile/cv/interests",
    component: _9c29ff40,
    name: "profile-cv-interests___en"
  }, {
    path: "/af/profile/cv/interests",
    component: _9c29ff40,
    name: "profile-cv-interests___af"
  }, {
    path: "/profile/cv/skills",
    component: _b857273e,
    name: "profile-cv-skills___en"
  }, {
    path: "/af/profile/cv/skills",
    component: _b857273e,
    name: "profile-cv-skills___af"
  }, {
    path: "/profile/cv/template",
    component: _72d70199,
    name: "profile-cv-template___en"
  }, {
    path: "/af/profile/cv/template",
    component: _72d70199,
    name: "profile-cv-template___af"
  }, {
    path: "/profile/cv/transport",
    component: _65e27100,
    name: "profile-cv-transport___en"
  }, {
    path: "/af/profile/cv/transport",
    component: _65e27100,
    name: "profile-cv-transport___af"
  }, {
    path: "/profile/cv/upload",
    component: _e949d140,
    name: "profile-cv-upload___en"
  }, {
    path: "/af/profile/cv/upload",
    component: _e949d140,
    name: "profile-cv-upload___af"
  }, {
    path: "/profile/cv/work-experience",
    component: _79dd6e3d,
    name: "profile-cv-work-experience___en"
  }, {
    path: "/af/profile/cv/work-experience",
    component: _79dd6e3d,
    name: "profile-cv-work-experience___af"
  }, {
    path: "/profile/cv/additional/achievement",
    component: _08778326,
    name: "profile-cv-additional-achievement___en"
  }, {
    path: "/af/profile/cv/additional/achievement",
    component: _08778326,
    name: "profile-cv-additional-achievement___af"
  }, {
    path: "/profile/cv/additional/external-link",
    component: _2911c573,
    name: "profile-cv-additional-external-link___en"
  }, {
    path: "/af/profile/cv/additional/external-link",
    component: _2911c573,
    name: "profile-cv-additional-external-link___af"
  }, {
    path: "/profile/cv/additional/external-links",
    component: _05582076,
    name: "profile-cv-additional-external-links___en"
  }, {
    path: "/af/profile/cv/additional/external-links",
    component: _05582076,
    name: "profile-cv-additional-external-links___af"
  }, {
    path: "/profile/cv/education/additional",
    component: _72f5d1e6,
    name: "profile-cv-education-additional___en"
  }, {
    path: "/af/profile/cv/education/additional",
    component: _72f5d1e6,
    name: "profile-cv-education-additional___af"
  }, {
    path: "/profile/cv/education/school",
    component: _57617b9a,
    name: "profile-cv-education-school___en"
  }, {
    path: "/af/profile/cv/education/school",
    component: _57617b9a,
    name: "profile-cv-education-school___af"
  }, {
    path: "/profile/cv/education/tertiary",
    component: _6ccfd438,
    name: "profile-cv-education-tertiary___en"
  }, {
    path: "/af/profile/cv/education/tertiary",
    component: _6ccfd438,
    name: "profile-cv-education-tertiary___af"
  }, {
    path: "/profile/cv/employability-awards/checklist",
    component: _8f96270c,
    name: "profile-cv-employability-awards-checklist___en"
  }, {
    path: "/af/profile/cv/employability-awards/checklist",
    component: _8f96270c,
    name: "profile-cv-employability-awards-checklist___af"
  }, {
    path: "/profile/cv/employability-awards/ChecklistItem",
    component: _44f0ede6,
    name: "profile-cv-employability-awards-ChecklistItem___en"
  }, {
    path: "/af/profile/cv/employability-awards/ChecklistItem",
    component: _44f0ede6,
    name: "profile-cv-employability-awards-ChecklistItem___af"
  }, {
    path: "/profile/cv/employability-awards/LogUpload",
    component: _5132ed99,
    name: "profile-cv-employability-awards-LogUpload___en"
  }, {
    path: "/af/profile/cv/employability-awards/LogUpload",
    component: _5132ed99,
    name: "profile-cv-employability-awards-LogUpload___af"
  }, {
    path: "/profile/cv/additional/achievement/:id",
    component: _f38fd1e4,
    name: "profile-cv-additional-achievement-id___en"
  }, {
    path: "/af/profile/cv/additional/achievement/:id",
    component: _f38fd1e4,
    name: "profile-cv-additional-achievement-id___af"
  }, {
    path: "/profile/cv/additional/external-link/:id?",
    component: _bdaeeeca,
    name: "profile-cv-additional-external-link-id___en"
  }, {
    path: "/af/profile/cv/additional/external-link/:id?",
    component: _bdaeeeca,
    name: "profile-cv-additional-external-link-id___af"
  }, {
    path: "/profile/cv/education/additional/:id",
    component: _42d10e96,
    name: "profile-cv-education-additional-id___en"
  }, {
    path: "/af/profile/cv/education/additional/:id",
    component: _42d10e96,
    name: "profile-cv-education-additional-id___af"
  }, {
    path: "/profile/cv/education/school/:id",
    component: _e724c6fc,
    name: "profile-cv-education-school-id___en"
  }, {
    path: "/af/profile/cv/education/school/:id",
    component: _e724c6fc,
    name: "profile-cv-education-school-id___af"
  }, {
    path: "/profile/cv/education/tertiary/:id",
    component: _743584a0,
    name: "profile-cv-education-tertiary-id___en"
  }, {
    path: "/af/profile/cv/education/tertiary/:id",
    component: _743584a0,
    name: "profile-cv-education-tertiary-id___af"
  }, {
    path: "/profile/cv/general-reference/:id?",
    component: _16315be5,
    name: "profile-cv-general-reference-id___en"
  }, {
    path: "/af/profile/cv/general-reference/:id?",
    component: _16315be5,
    name: "profile-cv-general-reference-id___af"
  }, {
    path: "/profile/cv/work-experience/:id?",
    component: _8d084836,
    name: "profile-cv-work-experience-id___en"
  }, {
    path: "/af/profile/cv/work-experience/:id?",
    component: _8d084836,
    name: "profile-cv-work-experience-id___af"
  }, {
    path: "/jobs/applications/:id",
    component: _408a3190,
    name: "jobs-applications-id___en"
  }, {
    path: "/af/jobs/applications/:id",
    component: _408a3190,
    name: "jobs-applications-id___af"
  }, {
    path: "/bursaries/:id",
    component: _f65c32f4,
    name: "bursaries-id___en"
  }, {
    path: "/af/bursaries/:id",
    component: _f65c32f4,
    name: "bursaries-id___af"
  }, {
    path: "/interviews/:id",
    component: _ecee1a72,
    name: "interviews-id___en"
  }, {
    path: "/af/interviews/:id",
    component: _ecee1a72,
    name: "interviews-id___af"
  }, {
    path: "/jobs/:id",
    component: _beaf4864,
    name: "jobs-id___en"
  }, {
    path: "/af/jobs/:id",
    component: _beaf4864,
    name: "jobs-id___af"
  }, {
    path: "/messages/:id",
    component: _39ad20fe,
    name: "messages-id___en"
  }, {
    path: "/af/messages/:id",
    component: _39ad20fe,
    name: "messages-id___af"
  }, {
    path: "/reset-password/:id?",
    component: _aa7005e4,
    name: "reset-password-id___en"
  }, {
    path: "/af/reset-password/:id?",
    component: _aa7005e4,
    name: "reset-password-id___af"
  }, {
    path: "/bursaries/:id/application",
    component: _3e360287,
    name: "bursaries-id-application___en"
  }, {
    path: "/af/bursaries/:id/application",
    component: _3e360287,
    name: "bursaries-id-application___af"
  }, {
    path: "/jobs/:id/application",
    component: _3fdecbcf,
    name: "jobs-id-application___en"
  }, {
    path: "/af/jobs/:id/application",
    component: _3fdecbcf,
    name: "jobs-id-application___af"
  }, {
    path: "/",
    component: _716188b8,
    name: "index___en"
  }, {
    path: "/af",
    component: _716188b8,
    name: "index___af"
  }],
  fallback: false
};
export function createRouter(ssrContext, config) {
  var base = config._app && config._app.basePath || routerOptions.base;
  var router = new Router(_objectSpread(_objectSpread({}, routerOptions), {}, {
    base: base
  })); // TODO: remove in Nuxt 3

  var originalPush = router.push;

  router.push = function push(location) {
    var onComplete = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;
    var onAbort = arguments.length > 2 ? arguments[2] : undefined;
    return originalPush.call(this, location, onComplete, onAbort);
  };

  var resolve = router.resolve.bind(router);

  router.resolve = function (to, current, append) {
    if (typeof to === 'string') {
      to = normalizeURL(to);
    }

    return resolve(to, current, append);
  };

  return router;
}